import { render, staticRenderFns } from "./CategoryNavItem.vue?vue&type=template&id=6236ad6b"
import script from "./CategoryNavItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryNavItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports